module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/QR_registro.7ed35780.svg";